import * as React from 'react';
import autobind from 'autobind-decorator';
import { state } from '__common/store';
import SVG from 'react-inlinesvg';
import Button from 'react-md/lib/Buttons/Button';
import { connect } from 'react-redux';
import { LOAD_PANELS_FROM_HISTORY, REDO_HISTORY } from '__editor/panelsEditor/actions';
import { DEBUG } from 'debug';

type RedoProps = onlyDispatchComponentState & {
  history: historyState,
};

class Redo extends React.Component<RedoProps, {}> {
  @autobind
  action() {
    const { dispatch, history } = this.props;

    if (!DEBUG.enablePanelsRedo || !history.canRedo) {
      return;
    }
   
    dispatch(REDO_HISTORY());

    const { history: updatedHistory } = state();
    const panels = updatedHistory.panelsSnapshot[updatedHistory.index];
    
    if (panels) {
      dispatch(LOAD_PANELS_FROM_HISTORY(panels));
    }
  }

  render() {
    const { history } = this.props;
    
    // hidden before release, will be fixed later

    if (!DEBUG.enablePanelsRedo) {
      return null;
    }
    
    return (
      <Button flat={true} onClick={this.action} className="roofs-selector-button" tooltipLabel="Redo" disabled={!history.canRedo}>
        <SVG src={require('assets/media/icons/icon_redo.svg')} />
      </Button>
    );
  }
}

function mapStateToProps(state: appState) {
  return {
    history: state.history,
  };
}

export default connect(mapStateToProps)(Redo);
